import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-35e73a7c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "kbf-tab"
};
import { ref } from 'vue';
import { CaretDownOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'KBFTab',

  setup(__props) {
    const {
      t
    } = useI18n();
    const introModal = ref(false);

    const toLink = () => {
      window.open('https:///kbfwhitepaper.one');
    };

    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "item",
        onClick: _cache[0] || (_cache[0] = $event => introModal.value = true)
      }, [_createTextVNode(_toDisplayString(_unref(t)('tokenIntroduction')), 1), _createVNode(_unref(CaretDownOutlined))]), _createElementVNode("div", {
        class: "item",
        onClick: toLink
      }, [_createTextVNode(_toDisplayString(_unref(t)('newWhitepaper')), 1), _createVNode(_unref(CaretDownOutlined))])]), _createVNode(_component_a_modal, {
        visible: introModal.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => introModal.value = $event),
        footer: null,
        width: "calc(100% - 20px)",
        centered: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(t)('kbfIntro1')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('kbfIntro2')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('kbfIntro3')), 1)]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }

};